import axiosInstance from "../../../../config/apiConfig"; 
import { useQuery } from "@tanstack/react-query";

export const getReportedPosts = async () => {
  try {
    const response = await axiosInstance.get(`/reports`);
    return response?.data?.reportedPosts || [];
  } catch (error) {
    console.error("Error fetching reported posts:", error);
    return [];
  }
};

const useReportedPosts = () => {
  return useQuery({
    queryKey: ["reportedPosts"], // unique cache key
    queryFn: getReportedPosts,
    keepPreviousData: true,
  });
};

export default useReportedPosts;